function UpcomingEvent(props) {
  const { time, tags, url, author, addToCalendar } = props;
  let { title } = props;
  const date = new Date(+time * 1000);
  const dateMonth = date.toLocaleDateString('en-US', { month: 'short' });
  const dateDate = date.toLocaleDateString('en-US', { day: 'numeric' });
  const dateTime = date.toLocaleTimeString('en-US', { timeStyle: 'short' });
  const timezone = new Date()
    .toLocaleTimeString('en-us', { timeZoneName: 'short' })
    .split(' ')[2];

  if (title) {
    title = <h4 className="upcoming-event__title">{title}</h4>;
    if (url) {
      title = <a href={url}>{title}</a>;
    }
  }

  return (
    <div className="upcoming-event">
      <div className="upcoming-event__date">
        {dateMonth}
        <div className="upcoming-event__date-big">{dateDate}</div>
      </div>
      {tags && (
        <ul className="upcoming-event__tags">
          {tags.map((tag, idx) => (
            <li key={tag.id}>
              {tag.name}
              {idx !== tags.length - 1 && ','}
            </li>
          ))}
        </ul>
      )}
      {title}
      {author && <div className="upcoming-event__author">{author}</div>}
      <div className="upcoming-event__footer">
        <span>{`${dateTime} ${timezone}`}</span>
        <div className="upcoming-event__footer-add-to-calendar">
          {addToCalendar}
        </div>
      </div>
    </div>
  );
}

export default UpcomingEvent;
